export default __webpack_public_path__ + "static/media/condo_dark.6a3e99cd.png";